<div class="push-dialog">
    <header class="push-dialog__header">
        <div class="push-dialog__heading">
            <h2 class="push-dialog__title">Push exercises to locations</h2>
            <p class="push-dialog__subtitle">
                {{ exerciseCount }} exercise{{ exerciseCount === 1 ? '' : 's' }} selected · choose where they should go
            </p>
        </div>
        <button
                mat-icon-button
                type="button"
                aria-label="Close"
                [disabled]="isLoading"
                (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="push-dialog__options" *ngIf="!isLoading">
        <mat-slide-toggle class="push-dialog__toggle" color="primary" [(ngModel)]="notifyUsers">
            <span class="push-dialog__toggle-title">Notify users at the destination locations</span>
            <span class="push-dialog__toggle-hint">Turn off to push silently — useful when correcting a mistake.</span>
        </mat-slide-toggle>

        <button mat-stroked-button type="button" class="push-dialog__all" (click)="pushToAll()">
            <mat-icon>public</mat-icon>
            Push to all locations
        </button>
    </div>

    <app-organizations-with-locations-form
            class="push-dialog__picker"
            (_cancel)="onCancel()"
            (_submit)="onSubmit($event)"
            [disabledLocationIds]="sourceLocationId ? [sourceLocationId] : []"
            [requireActive]="true"
            [confirmationPrefix]="confirmationPrefix"
            submitLabel="Push exercises"
            *ngIf="!isLoading">
    </app-organizations-with-locations-form>

    <div class="push-dialog__loading" *ngIf="isLoading">
        <mat-spinner diameter="34"></mat-spinner>
        <p>Starting the push…</p>
    </div>
</div>
